import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pageSetter: {
    isCrewPage: true,
    poListType: 'crew' // 'crew' | 'vessel' | 'agency'
  }
};

const fliterSlice = createSlice({
  name: 'pageHanlder',
  initialState,
  reducers: {
    updatePage: (state, action) => {
      const { payload } = action;
      if (typeof payload === 'boolean') {
        state.pageSetter.isCrewPage = payload;
        state.pageSetter.poListType = payload ? 'crew' : 'vessel';
      } else if (payload === 'crew' || payload === 'vessel' || payload === 'agency') {
        state.pageSetter.poListType = payload;
        state.pageSetter.isCrewPage = payload === 'crew';
      }
    },
    resetPage: () => initialState
  }
});

export default fliterSlice.reducer;
export const { updatePage, resetPage } = fliterSlice.actions;
